import { AHIcon, AHIconType } from "./AHIcon";
import { Box, TouchableBox } from "./AHTheme/Box";
import { AHText } from "./Text/AHText";

export function SelectBox(props: {
  isSelected?: boolean;
  icon: AHIconType;
  children: React.ReactNode;
  onPress: () => void;
  disabled?: boolean;
}) {
  return (
    <TouchableBox
      onPress={props.onPress}
      disabled={props.disabled}
      space="medium"
      spaceHorizontal="small"
      style={{
        height: 100,
        flex: 1,
        opacity: props.disabled && !props.isSelected ? 0.4 : 1,
      }}
    >
      <Box
        cornerRadius="large"
        color={props.disabled ? "transparent" : "surface-primary"}
        borderColor={props.isSelected ? "border-cta" : "border-strong"}
        style={{ borderWidth: 3, flex: 1 }}
      >
        <Box
          space="small"
          style={{
            flex: 1,
            justifyContent: "space-between",
          }}
        >
          <AHIcon
            type={props.icon}
            color={props.isSelected ? "primary" : "darkText"}
          />
          <AHText
            numberOfLines={1}
            color={props.isSelected ? "primary" : "darkText"}
          >
            {props.children}
          </AHText>
        </Box>
      </Box>
    </TouchableBox>
  );
}
